import React from 'react';
import Select, { StylesConfig, SingleValue, components, DropdownIndicatorProps, InputProps } from 'react-select';
import styles from './InputDateSelectElement.module.css';
import { Icon } from '../../../foundations';
type SelectOption = {
	value?: number | null;
	label: string;
};

type SelectProps = {
	options: SelectOption[];
	onChange: (selectedOption: SingleValue<SelectOption>) => void;
	value: SelectOption | null;
	name?: string;
	ariaLabel?: string;
	disabled?: boolean;
	maxLength?: number;
};

const customSelectStyles: StylesConfig<SelectOption, false> = {
	control: (provided, state: { isFocused: boolean }) => ({
		...provided,
		minHeight: 'auto',
		maxWidth: 'fit-content',
		background: 'inherit',
		margin: '0',
		border: 'none',
		borderColor: 'transparent',
		borderRadius: 'none',
		boxShadow: state.isFocused ? '0 2px 3px #00000052, 0 -1px 4px #0000001c' : 'none',
		'&:hover': {
			borderColor: 'transparent'
		}
	}),
	singleValue: (baseStyles, state) => ({
		...baseStyles,
		color: state.getValue()[0]?.value ? 'var(--grey-800-33)' : 'var(--grey-700-66)',
		fontSize: '1rem'
	}),
	valueContainer: (baseStyles) => ({
		...baseStyles
	}),
	input: (baseStyles) => ({
		...baseStyles,
		margin: '0'
	}),
	indicatorSeparator: () => ({
		display: 'none'
	}),
	dropdownIndicator: (_, state) => ({
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
		transition: 'transform 0.25s'
	}),
	menu: (baseStyles) => ({
		...baseStyles,
		zIndex: 10,
		margin: 0
	}),
	menuList: (baseStyles) => ({
		...baseStyles,
		outline: 'none',
		background: 'var(--neutrals-white, #FFF)',
		boxShadow: '0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.25)',
		'&::-webkit-scrollbar': {
			width: '0.3125rem'
		},
		'&::-webkit-scrollbar-track': {
			border: '0.125rem solid var(--grey-100-fa)',
			backgroundColor: 'var(--neutrals-white)',
			borderRadius: '0.75rem'
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'var(--grey-600-99)',
			borderRadius: '0.75rem',
			height: '6.125rem'
		}
	}),
	option: (provided, state: { isFocused: boolean }) => ({
		...provided,
		backgroundColor: state.isFocused ? 'var(--grey-100-fa)' : 'var(--neutrals-white)',
		color: 'var(--grey-800-33)'
	})
};

const DropdownIndicator = (props: DropdownIndicatorProps) => {
	return (
		<components.DropdownIndicator className={styles.inputSelectArrowIcon} {...props}>
			<Icon name="chevron-line-down"></Icon>
		</components.DropdownIndicator>
	);
};

const Input = (props: InputProps & { selectProps: { maxLength: number; name: string } }) => {
	return (
		<components.Input
			{...props}
			maxLength={props.selectProps.maxLength}
			type="text"
			data-testid={props.selectProps.name}
		/>
	);
};

export const InputDateSelectElement: React.FC<SelectProps> = ({ options, value, ariaLabel, disabled, ...props }) => {
	return (
		<Select
			className={styles.select}
			classNamePrefix="SelectDate"
			styles={customSelectStyles as StylesConfig<unknown, false>}
			options={options}
			maxMenuHeight={180}
			menuPlacement="auto"
			aria-label={ariaLabel}
			value={value ?? null}
			isDisabled={disabled}
			menuPosition="absolute"
			noOptionsMessage={() => null}
			{...props}
			//@ts-expect-error react-select library doesn´t support custom properties. https://react-select.com/typescript
			components={{ DropdownIndicator, Input }}
		/>
	);
};
